
import { PipelineToolbar } from './toolbar';
import { PipelineUI } from './ui';

function App() {
  return (
    <div>
      <PipelineToolbar />
      <PipelineUI />
    </div>
  );
}

export default App;
